import { AbstractSortValueOfArrayCommand } from "./AbstractSortValueOfArrayCommand";

export class SortValueOfArrayCommand<TSource, TValue> extends AbstractSortValueOfArrayCommand<TSource, TValue> {
  constructor(private readonly _readArray: (s: TSource) => TValue[], compare: (a: TValue, b: TValue) => number) {
    super(compare);
  }

  protected readArray(source: TSource): TValue[] {
    return this._readArray(source);
  }
}
